import React from 'react'
import { Button } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'
import { pdf } from '@react-pdf/renderer'
import * as FileSaver from 'file-saver'
import { emca_catalog } from '../../../../escalas/emca/emca.catalog'
import EmcaPDF from '../../printed-docs/printed-scales/emca-pdf'

// Responses: [Muy de acuerdo, Bastante de acuerdo, Ni de acuerdo ni en desacuerdo, Bastante en desacuerdo, Muy en desacuerdo]

const rss = ["Muy de acuerdo", "Bastante de acuerdo", "Ni de acuerdo ni en desacuerdo", "Bastante en desacuerdo", "Muy en desacuerdo"]

export default function EmcaResults({ emca, pacienteData, fecha }) {
    if (!emca) return null

    const score = emca.reduce((a, v) => a + v, 0)

    const handlePrint = async () => {
        const blob = await pdf(<EmcaPDF pacienteData={pacienteData} fecha={fecha} emca={emca} />).toBlob()
        FileSaver.saveAs(blob, `emca_${pacienteData?.name || 'paciente'}.pdf`)
    }

    return (
        <div>
            <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
                <td><strong>Puntuación total: {score}</strong></td>
            </tr>
            {emca_catalog.map((pr, i) => (
                <tr key={i} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                    <td>{pr}</td>
                    <td>{rss[emca[i]]}</td>
                </tr>
            ))}
            <div style={{ marginTop: 10, textAlign: 'right' }}>
                <Button icon={<PrinterOutlined />} onClick={handlePrint}>Imprimir escala en pdf</Button>
            </div>
        </div>
    )
}
